module.exports = __webpack_public_path__ + "static/img/other-panduanti.e4dac8cb.png";